export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/es.lyaml"));
at({ "es": { "public": { "sampleString": "Cadena de ejemplo" } } });
};